module.exports = __webpack_public_path__ + "img/logo.8df75666.png";